module.exports = __webpack_public_path__ + "img/newimg8.8eadaecb.jpg";